import { useTranslation } from 'react-i18next';

interface PointsByCategory {
  climb: number;
  social: number;
}

interface PointsDisplayProps {
  totalPoints: number;
  pointsByCategory?: PointsByCategory;
}

export default function PointsDisplay({ totalPoints, pointsByCategory }: PointsDisplayProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-1">
      <span className="text-2xl font-bold text-primary">
        {totalPoints} {t('userProfile.totalPoints')}
      </span>
      {pointsByCategory && (totalPoints > 0) && (
        <span className="text-sm text-muted-foreground">
          {t('userProfile.pointsBreakdown.climb')}: {pointsByCategory.climb}
          {' · '}
          {t('userProfile.pointsBreakdown.social')}: {pointsByCategory.social}
        </span>
      )}
    </div>
  );
}
